import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs';
import { environment } from 'src/environments/environment';
import { GiftCategory } from '../_models/giftCategory';
import { GiftDetail } from '../_models/giftDetail';
import { AuthHeader } from '../_models/headers';
import { AuthService } from './auth.service';
import { DataUtilService } from './data-util.service';

@Injectable({
  providedIn: 'root'
})
export class GiftingService {
  aHeader = undefined
  constructor(private http: HttpClient,private dataUtilService:DataUtilService,private tss:AuthService) {this.aHeader = new AuthHeader(tss) }
  getCategories() {
    return this.http.get<any>(`${environment.apiUrl}/giftCategory/listAll`,this.aHeader.openJsonHeaders).pipe(map(data => {
      let myData=[]
      if(this.dataUtilService.isGoodResponse(data)){
        myData= this.dataUtilService.myData(data)
      }
      return myData
    }))
  }

  getGiftCategory(id:number) {
    return this.http.get<any>(`${environment.apiUrl}/giftCategory/show/${id}`,this.aHeader.openJsonHeaders).pipe(map(data => {

      if(this.dataUtilService.isGoodResponse(data)){
        return this.dataUtilService.myData(data)
      }

    }))
  }
  newGiftCategory(syllabusItem: GiftCategory) {
    return this.http.post(`${environment.apiUrl}/giftCategory/saveapi`, syllabusItem.formData(), this.aHeader.bearerFormHeaders)
      .pipe(map(sInfo => {
        if(this.dataUtilService.isGoodResponse(sInfo)){
         return this.dataUtilService.myData(sInfo)
        }
      }));
  }

  editGiftCategory(syllabusItem: GiftCategory) {
    return this.http.post(`${environment.apiUrl}/giftCategory/editapi`, syllabusItem.formData(), this.aHeader.bearerFormHeaders)
      .pipe(map(sInfo => {
        if(this.dataUtilService.isGoodResponse(sInfo)){
         return this.dataUtilService.myData(sInfo)
        }
      }));
  }

  getGifts() {
    return this.http.get<any>(`${environment.apiUrl}/giftDetail/listAll`,this.aHeader.openJsonHeaders).pipe(map(data => {
      let myData=[]
      if(this.dataUtilService.isGoodResponse(data)){
        myData= this.dataUtilService.myData(data)
      }
      return myData
    }))
  }

  getGiftDetail(id:number) {
    return this.http.get<any>(`${environment.apiUrl}/giftDetail/show/${id}`,this.aHeader.openJsonHeaders).pipe(map(data => {

      if(this.dataUtilService.isGoodResponse(data)){
        return this.dataUtilService.myData(data)
      }

    }))
  }
  newGiftDetail(syllabusItem: GiftDetail) {
    return this.http.post(`${environment.apiUrl}/giftDetail/saveapi`, syllabusItem.formData(), this.aHeader.bearerFormHeaders)
      .pipe(map(sInfo => {
        if(this.dataUtilService.isGoodResponse(sInfo)){
         return this.dataUtilService.myData(sInfo)
        }
      }));
  }

  editGiftDetail(syllabusItem: GiftDetail) {
    return this.http.post(`${environment.apiUrl}/giftDetail/editapi`, syllabusItem.formData(), this.aHeader.bearerFormHeaders)
      .pipe(map(sInfo => {
        if(this.dataUtilService.isGoodResponse(sInfo)){
         return this.dataUtilService.myData(sInfo)
        }
      }));
  }
}
